import cx from "classnames"
import * as React from "react"

const TitleWord = ({ className, children }) => {
  return (
    <div
      className={cx(
        className,
        "px-8 shrink whitespace-nowrap text-mobile-word mobile:text-mobile-5xl tablet:text-5xl h-16 mobile:h-28 tablet:h-44 rounded-lg mobile:rounded-tab tablet:rounded-header flex items-center justify-center capitalize"
      )}
    >
      {children}
    </div>
  )
}

export default TitleWord
